import React from 'react';
import { datetime } from '@common/services/datetime';
import { Form } from 'antd';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { DatePicker, Modal, TextAreaEmojiPicker } from '@common/components';
import { WorksListDueDateMutation } from '@working-experience/graphql/mutations';

export const AssignmentOnboardingDueDateModal = ({
  visible,
  worksListId,
  deadlineDetails,
  deadlineDueDate,
  onClose,
}: {
  visible: boolean;
  worksListId: string;
  deadlineDetails?: string;
  deadlineDueDate?: string;
  onClose: () => void;
}) => {
  const [form] = Form.useForm();

  const errorMessage = () =>
    createMessage('error', 'Failed to save due date. Please try again.');

  const [save, { loading }] = useMutation(WorksListDueDateMutation, {
    onCompleted: (response) => {
      if (response?.error) {
        errorMessage();
      } else {
        createMessage('success', 'Due date saved successfully');
        onClose();
      }
    },
    onError: errorMessage,
  });

  function onFormSubmit(values: { dueDate: string; details: string }) {
    save({
      variables: {
        worksListId,
        input: {
          deadlineDueDate: values.dueDate,
          deadlineDetails: values.details,
        },
      },
    });
  }

  return (
    <Modal
      title="Compliance Due Date"
      visible={visible}
      onOk={form.submit}
      onCancel={onClose}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          dueDate: handleInitialDuoDate(deadlineDueDate),
          details: deadlineDetails,
        }}
        onFinish={onFormSubmit}
      >
        <Form.Item
          label="Due Date"
          name="dueDate"
          rules={[
            {
              required: true,
              message: 'Please enter due date',
            },
          ]}
        >
          <DatePicker
            placeholder="mm/dd/yyyy"
            format="MM/DD/YYYY"
            size="large"
            style={{ width: 360 }}
          />
        </Form.Item>
        <Form.Item
          label="Deadline Details"
          name="details"
          rules={[
            {
              required: true,
              message: 'Please enter deadline details',
            },
          ]}
        >
          <TextAreaEmojiPicker size="large" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

function handleInitialDuoDate(date?: string) {
  return date ? datetime(date) : undefined;
}
